/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/presentation/presentation',['require','underscore','jquery','core/base-screen'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var BaseScreen = require('core/base-screen');

  /*****************************************************************************************************************///}

  var Presentation = BaseScreen.extend({

  /////////////
  // METHODS /{
  /////////////
    skippable: true,

    onShow: function()
    {
      if (this.page.get('earnedPoints') === 0)
      {
        this.page.set('earnedPoints', 0.1);
      }

      if (this.model.get('media'))
      {
        this.playMedia(null, {showBtns: true});
        //console.log('model', this);
        if (this.page.get('mustComplete') && !this.page.collection.parent.seen() && !this.page.get('complete'))
        {
          //console.log('disable next');
          this.radio.trigger('ui.update', {next:false});
        }
      }
      else
      {
        this.finish();
      }
    },

    onMediaEnded: function(e)
    {
      if ($('body .media-test').length)
        return;

      BaseScreen.prototype.onMediaEnded.apply(this, arguments);
      if (this.channel)
        this.channel.showPoster();//this.channel.seekTo(99.9);

      this.finish();

      if (this.model.get('outroText'))
        this.setupFeedback();
    },

    setupFeedback: function()
    {
      this.radio.trigger('ui.update', {next: false, help: false, home: false});
      this.$el.find('.overlay-title h1').html(this.page.collection.parent.get('title'));
      this.$el.find('.overlay-container [data-mc=text_tf]').html(this.model.get('outroText'));
      this.$el.find('[data-mc=overlay_mc]').show();
      this.$el.addClass('page-complete');

      if (this.channel)
        this.channel.cleanup(true);

      this.$el.find('[data-mc=overlay_mc] [data-mc=return_mc]').one('click', _.bind(this.goNext, this));//this.radio.trigger('ui.button.pressed.next');)
    },

    goNext: function()
    {
      this.radio.trigger('ui.button.pressed.next');
    },

  /*****************************************************************************************************************///}

  });

  return Presentation;

});

